import { connect } from 'react-redux';
import JournalPartnerTagAdminAddScreen from '../components/JournalPartnerTagAdminAddScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    isLoading: state.journalPartnerTagsAdmin.get('isLoading'),
    success: state.journalPartnerTagsAdmin.getIn(['form', 'success']),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const JournalPartnerTagAdminAddScreenContainer = connect(mapStateToProps)(
  JournalPartnerTagAdminAddScreen
);

export default JournalPartnerTagAdminAddScreenContainer;
